import pattern from 'patterns/image';
import { WCCContentImageBlock } from '../blocks/image/image';
import WCCContentPatternRule from './pattern';

export default class WCCContentImageRule extends WCCContentPatternRule {
    protected pattern = pattern;

    protected process([content,,protocol]: RegExpMatchArray) {
        const url = content.replace(protocol, 'https://');

        return new WCCContentImageBlock({ content, url });
    }
}